/**
 * Les couleurs de `<LiveViewSwitch>` : pures (aucun Unistyles), pour que `theme/contrast.test.ts` mesure la
 * bascule telle qu'elle se peint, dans les deux thèmes de l'élève.
 *
 * Seul le segment choisi est dans l'univers (Wajih, daily du 23/10 : en clair, l'onglet choisi ne se
 * distinguait pas assez de l'autre, écrit lui aussi en orange) : l'aplat d'une option choisie, son libellé
 * blanc. L'autre est écrit à l'encre secondaire, à même la piste. La piste est le fond de page, creusée
 * dans l'en-tête : sur la nuit, l'aplat ne se détachait d'un encart qu'à 2,5:1.
 */
import type { SemanticColorKey } from "../../theme/tokens/colors"

export const LIVE_VIEW_SWITCH_FACE = {
    /** La piste, posée sur l'en-tête du live (`surface-raised`). */
    track: "surface",
    /** Le segment choisi, qui glisse. */
    chosen: "role-selected",
    chosenInk: "text-on-role",
    /** Le segment qui ne l'est pas. */
    otherInk: "text-muted",
} as const satisfies Record<string, SemanticColorKey>
